export default "__VITE_ASSET__ChhxJ2tQ__"